import { PredictionSummaryData } from "../../types";
import AssessmentCard from "./assessmentCard";

/**
 * Props for the Answer Assessment tab.
 */
interface AnswerAssessmentTabProps {
  /** Evaluation engine payload containing answer assessments. */
  data: PredictionSummaryData;
}

/**
 * Answer Assessment tab listing per-question verdicts with Q&A.
 *
 * @param props.data - Prediction summary payload
 */
const AnswerAssessmentTab = (props: AnswerAssessmentTabProps) => {
  const assessments = props.data.answer_assessment ?? [];

  if (assessments.length === 0) {
    return (
      <div className="py-6 text-center text-small text-primaryGray-6">
        No answer assessments available.
      </div>
    );
  }

  return (
    <div className="prediction-summary-modal__answer-assessment flex flex-col gap-3 p-2 mb-2 overflow-y-auto">
      {assessments.map((item) => (
        <AssessmentCard key={item.q_idx} item={item} />
      ))}
    </div>
  );
};

export default AnswerAssessmentTab;
